import { IMessage } from '../stores/chat.store';

export const scrollToBottom = (message?: IMessage) => {
    setTimeout(() => {
        const { id, scrollToId } = message ?? {};
        if (id && scrollToId) {
            const el = document.getElementById(id.toString());
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'end' });
                return;
            }
        }
        const scrollContainer = document.querySelector('#messages-container');
        scrollContainer?.scrollTo({
            top: scrollContainer.scrollHeight,
            behavior: 'smooth',
        });
    });
};
